import { Cookie } from "@mui/icons-material";
import useAuth from "./useAuth";
import { User } from "store/slices/auth";
import { browser, getVid, getSid } from "utils";
interface Detail {
  [key: string]: string | number | boolean | object | undefined | null;
}
interface Properties {
  uid: string; // 当前账号选中的角色UID
  fpid: string; // 当前账号选中的角色对应的FPID
  gameserver_id: string | number; // 当前账号选中的角色所在的服务器ID
  from_game_id: string; // 进入游戏，从游戏进到私域带过来的game_id，非游戏内进入为空
  from_game_project: string; // 进入游戏，从游戏进到私域带过来的game_project，非游戏内进入为空
  ip: string; // 用户IP地址
  os: string; // 用户操作系统 android/ios windows
  device_info: string; // 用户设备信息
  device_id: string; // 设备ID
  session_id: string; // 会话ID
}

interface Basic {
  funplus_id: string; // 用户ID
  app_id: string; // 项目id
  event: string; // 事件名称
  event_ts: number; // 事件时间戳
  event_tag: string; // 事件标签
  data_version: string; // 日志协议版本号，默认1.0
  log_source: string; // 埋点来源 ● wp：web page-web前端 ● ws：web server-web后端
  properties: Properties; // 属性字段
  detail: Detail; // 扩展字段
}

let userData: any;

export const send = async (event: string, detail?: Detail, user?: User | null) => {
  try {
    // 配置打点：core custom
    const app_id = "funplay.global.dev";
    const event_tag = "core";
    // console.log("userData111", userData);
    // 需要补充 from_game_id from_game_project os
    const { pathname, href } = window.location;

    const basic: Basic = {
      app_id,
      event,
      event_ts: new Date().getTime(),
      event_tag,
      data_version: "1.0",
      log_source: "wp",
      funplus_id: localStorage.getItem("fp_uid") || "",
      properties: JSON.parse(localStorage.getItem("properties") || "{}"),
      detail: {
        pathname,
        url: href,
        ...detail
      }
    };

    navigator.sendBeacon(`https://priv-platform-api-test.funplus.com/log/send_text`, JSON.stringify(basic));
  } catch (error) {
    console.log("useLog error", error);
  }
};

export const useLog = () => {
  const { user } = useAuth();
  userData = user;

  const log = (event: string, detail?: Detail) => {
    send(event, detail, userData);
  };

  return log;
};

export default useLog;
